import { Context, useContext } from 'react';

export function useStore<T>(storeContext: Context<T>) {
  return useContext(storeContext);
}
